<!--
Non-bootstrap version of Confirm.vue - intended to be a drop-in replacement.
bootstrap modals are breaking with $.... modal is not a function :-(

@author cm359n
-->
<template>
  <div>
    <NewModalPopup v-if="showConfirm" id="confirm" title="Confirm" displayAt="top">
      <p>{{ msg }}</p>
      <div class="w-100">
        <div class="btn-group w-100" role="group" aria-label="confirm buttons">
          <button type="button" class="btn btn-primary"
            @click="doOkCallback()">OK</button>
          <button type="button" class="btn btn-secondary"
            @click="doCancelCallback()">Cancel</button>
        </div>
      </div>
    </NewModalPopup>
  </div>
</template>

<script setup>
//Utilities
import { ref, defineExpose } from 'vue'

//Components
import NewModalPopup from '@/components/NewModalPopup.vue'

//Data
const msg = ref('')
const showConfirm = ref(false)

//Submit and cancel functions that will have their function replaced by the parameters of the 'show' function
let onOkCallback = () => {}
let onCancelCallback = () => {}

// we should close this thing when ok/cancel are called
// we don't get that for free with this non-bootstrap version
function doOkCallback () {
  showConfirm.value = false
  onOkCallback()
}

function doCancelCallback () {
  showConfirm.value = false
  onCancelCallback()
}


 // Used by container components to show the dialogue.
// As this is a global component, if callbacks are not defined they revert to noop.
const show = (message = '', okCallback = defaultOkCallback, cancelCallback = defaultCancelCallback) => {
  msg.value = message

  onOkCallback = okCallback
  onCancelCallback = cancelCallback

  showConfirm.value = true
}

defineExpose({
  show
})

// Default callback function called when the OK button is clicked.
// Container components can override this.
function defaultOkCallback () {
  noop()
}
// Default callback function called when the Cancel button is clicked.
// Container components can override this.
function defaultCancelCallback () {
  noop()
}
// No op function for default/unspecified callbacks.
function noop () {
  console.log('noop')
}

</script>
